module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAoCAYAAADHVmuAAAAAAXNSR0IArs4c6QAAAQ1JREFUOE/tlT1qw0AUhGeWYNhVb5PkGO4tfIiUaUNOkB8I1koY8nMD49JljhAIsgrji0Rx0lsGNS94E0xWICllCr3uPb5qmDfDMyu9T+ymEDnHfshFH/ru2bJ0+88wjIpHEbnyjuTTMjbX3m002eYAjn8fAbxnSXBSBaUCuTVLAnYgR5NtJ8/BBwq4TJNgdvBjnTwgyyNi/GrNyvm5FnRmx6ZHDF9skDeC35/BdZ86bAUdrDD/EwilZu0guRpQj5tBMlfUw9RyUw+SpSLC1Jp1ozyEulgmet4qePeujTr+K3mi4g0iXgyDzLPYnPqJGxX3ELnx4pl8yGJz64H7+viQXUyBqw8hFgPqqFofX6ClwHhJhBhzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/icon-common-vertical-line.png
// module id = InVU
// module chunks = 1